export default {
    methods: {
        getTranslation(textContent) {
            if (!textContent) {
                return
            }
            if (this.$i18n?.locale === textContent?.originalLanguage) {
                return textContent?.originalText
            }

            return textContent[`translation${this.$i18n?.locale.toUpperCase()}`] ?? textContent?.originalText
        },
    },
}
